import { DatePipe, formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { PaymentService } from 'app/services/payment.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'app-list-register-payment',
  templateUrl: './list-register-payment.component.html',
  styleUrls: ['./list-register-payment.component.css'],
})
export class ListRegisterPaymentComponent implements OnInit {

  @ViewChild('statusTpl') statusTpl: TemplateRef<any>;
  @ViewChild('hdrTplWithSelectOptionSearch') hdrTplWithSelectOptionSearch: TemplateRef<any>;
  @ViewChild('paymentDateTpl') paymentDateTpl: TemplateRef<any>;
  @ViewChild('createDateTpl') createDateTpl: TemplateRef<any>;

  profiledata: any;
  rows = [];
  columns = [];
  dataRows = [];
  adminUser: Boolean = false;
  unPaid: Boolean = false;
  allPayment: Boolean = false;
  submitted = false;
  error = false;
  success = false;
  dataJSON: any;
  title: String = '';
  monthList = [];
  allRows = [];
  tempRows = [];
  excelRows = [];

  defaultSort = [
    {
      prop: 'createDate',
      dir: 'desc'
    }
  ];

  header: string[] = [];

  constructor(
    private router: Router,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private authService: AuthService,
    private paymentService: PaymentService,
    @Inject(LOCALE_ID) private locale: string,
    private datePipe: DatePipe
  ) {

    this.spinnerService.start();

    this.configPage(this.router.url.split('/')[2]);

    this.adminUser = this.authService.isAdmin();


    this.paymentService.getMonthOptionsForRegisterPayment(this.adminUser).subscribe(dataOptions => {
      this.monthList = dataOptions;

      this.monthList.forEach(function (part, index) {
        this[index] = formatDate(this[index], 'MMMM-yyyy', 'it');
        this[index] = this[index].charAt(0).toUpperCase() + this[index].slice(1);
      }, this.monthList);

      this.getPaymentList();
      this.spinnerService.stop();
    });

    this.paymentService.getRegisterPaymentList(this.adminUser, false, true).subscribe(data => {
      /* console.log(data); */
      this.allRows = data;
    });
  }

  getPaymentList() {
    this.paymentService.getRegisterPaymentList(this.adminUser, this.unPaid, this.allPayment).subscribe(data => {
      this.rows = data;
      this.dataRows = this.rows;
      /* console.log(this.rows); */
    });
  }


  configPage(val) {
    switch (val) {
      case "month":
        {
          this.unPaid = false;
          this.allPayment = false;
          this.commonUtilService.translateLang("HRWE.PAGE_TITLE.LIST_PAYMENT_MONTH");
          this.title = "HRWE.PAGE_TITLE.LIST_PAYMENT_MONTH";
          break;
        }
      case "unpaid":
        {
          this.unPaid = true;
          this.allPayment = false;
          this.commonUtilService.translateLang("HRWE.PAGE_TITLE.LIST_PAYMENT_DAY");
          this.title = "HRWE.PAGE_TITLE.LIST_PAYMENT_DAY";
          break;
        }
      case "all":
        {
          this.unPaid = false;
          this.allPayment = true;
          this.commonUtilService.translateLang("HRWE.PAGE_TITLE.LIST_PAYMENT");
          this.title = "HRWE.PAGE_TITLE.LIST_PAYMENT";
          break;
        }
    }
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: 'Mese', prop: 'month', sortable: true, headerTemplate: this.hdrTplWithSelectOptionSearch, resizeable: false, width: 140 },
      { name: 'Numero Report', prop: 'requestNumber', sortable: true, resizeable: false, width: 160, comparator: this.columnRequestNumberComparator.bind(this) },
      { name: 'Numero Visura', prop: 'candidateUuid', sortable: true, resizeable: false, width: 300 },
      { name: 'Nome', prop: 'candidateFirstName', sortable: true, resizeable: false, width: 120 },
      { name: 'Cognome', prop: 'candidateLastName', sortable: true, resizeable: false, width: 120 },
      { name: 'Candidate Email', prop: 'candidateEmail', sortable: true, resizeable: false, width: 200 },
      { name: 'Data di pagamento', prop: 'paymentDate', cellTemplate: this.paymentDateTpl, sortable: true, resizeable: false, width: 180, comparator: this.columnPaymentDateComparator.bind(this) },
      { name: 'Data di Creazione', prop: 'createDate', cellTemplate: this.createDateTpl, sortable: true, resizeable: false, width: 180, comparator: this.columnCreateDateComparator.bind(this) },
      /* { name: 'Stato', sortable: false, resizeable: false, cellTemplate: this.statusTpl, width: 100  }, */
    ];

    if (this.adminUser) {
      this.columns.splice(1, 0, { name: 'HR Utente', prop: 'hrUserEmail', sortable: true, resizeable: false, width: 200 });
    }
  }

  ngOnInit() {

  }

  filterByMonth(event) {
    /* console.log(event.target.value); */

    if (event.target.value === '') {
      this.rows = this.dataRows;
      return;
    }
    let splited = event.target.value.split('-');
    let selMonth = splited[0];
    let selYear = splited[1];

    this.tempRows = this.allRows;

    this.rows = this.tempRows.filter(row => {
      const isPartialMonthMatch = row.month !== null && row.month.indexOf(selMonth) !== -1;
      const isPartialYearMatch = row.createDate !== null && new Date(row.createDate).getFullYear().toString() === selYear;
      if (this.unPaid && !this.allPayment) {
        const isPartialUnpaidStatusMatch = row.status !== null && row.status.toString() === 'UN_PAID';
        return isPartialMonthMatch && isPartialYearMatch && isPartialUnpaidStatusMatch;
      } else {
        return isPartialMonthMatch && isPartialYearMatch;
      }
    });
  }

  changeStatus($event, id) {
    this.spinnerService.start();

    var status = "UN_PAID";
    if ($event.target.checked) {
      status = "PAID";
    }

    this.paymentService.updateRegisterPaymentStatus(id, status).subscribe(data => {
      this.getPaymentList();
      this.spinnerService.stop();
    });

  }

  columnRequestNumberComparator(propA, propB, rowA, rowB) {
    if (Number(rowA.requestNumber) < Number(rowB.requestNumber)) { return -1; }
    if (Number(rowA.requestNumber) > Number(rowB.requestNumber)) { return 1; }
  }

  columnPaymentDateComparator(propA, propB, rowA, rowB) {
    if (rowA.paymentDate != null && rowB.paymentDate != null && rowA.paymentDate < rowB.paymentDate) { return -1; }
    if (rowA.paymentDate != null && rowB.paymentDate != null && rowA.paymentDate > rowB.paymentDate) { return 1; }
  }

  columnCreateDateComparator(propA, propB, rowA, rowB) {
    if (rowA.createDate < rowB.createDate) { return -1; }
    if (rowA.createDate > rowB.createDate) { return 1; }
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Consumption', this.excelRows, "Tutti i Consumi - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(true, this.header, this.excelRows, "Tutti i Consumi - HRWE.pdf");
    
  }

  exportRows() {

    if(this.adminUser){
      this.header = ['Mese', 'HR Utente', 'Numero Report', 'Numero Visura', 'Nome', 'Cognome', 'Candidate Email', 'Data di pagamento', 'Data di Creazione'];
      let arr = this.rows.map(row => {
        return {
          'Mese': row.month,
          'HR Utente': row.hrUserEmail,
          'Numero Report': row.requestNumber,
          'Numero Visura': row.candidateUuid,
          'Nome': row.candidateFirstName,
          'Cognome': row.candidateLastName,
          'Candidate Email': row.candidateEmail,
          'Data di pagamento': row.paymentDate ? this.datePipe.transform(row.paymentDate, 'dd/MM/yyyy') : ' ',
          'Data di Creazione': this.datePipe.transform(row.createDate, 'dd/MM/yyyy'),
        }
      });
      return arr;
    } else {
      this.header = ['Mese', 'Numero Report', 'Numero Visura', 'Nome', 'Cognome', 'Candidate Email', 'Data di pagamento', 'Data di Creazione'];
      let arr = this.rows.map(row => {
        return {
          'Mese': row.month,
          'Numero Report': row.requestNumber,
          'Numero Visura': row.candidateUuid,
          'Nome': row.candidateFirstName,
          'Cognome': row.candidateLastName,
          'Candidate Email': row.candidateEmail,
          'Data di pagamento': row.paymentDate ? this.datePipe.transform(row.paymentDate, 'dd/MM/yyyy') : ' ',
          'Data di Creazione': this.datePipe.transform(row.createDate, 'dd/MM/yyyy'),
        }
      });
      return arr;
    }
  }

}
